// Payment status for a filing's reconcile/payment block. Replaces the old free-text field with a
// small, consistent set. "No payment due" is the $0-owed case (nothing to remit).
export type PaymentStatus = 'not_scheduled' | 'scheduled' | 'no_payment_due';

export const PAYMENT_STATUSES: PaymentStatus[] = ['not_scheduled', 'scheduled', 'no_payment_due'];

// Normalize a stored/extracted value (canonical enum, or legacy free-text like "IN PROCESS")
// into a PaymentStatus. Unknown/empty → not_scheduled.
export function paymentStatusFromExtracted(raw: string | null | undefined): PaymentStatus {
  if (!raw) return 'not_scheduled';
  const v = raw.trim().toLowerCase();
  if (v === 'no_payment_due') return 'no_payment_due';
  if (v === 'not_scheduled') return 'not_scheduled';
  if (['scheduled', 'in process', 'in-process', 'inprocess', 'completed', 'complete', 'confirmed', 'paid'].includes(v))
    return 'scheduled';
  return 'not_scheduled';
}

// "No payment due" is derived when the filed amount due is exactly 0.
export function isNoPaymentDue(amountDue: number | null | undefined): boolean {
  return amountDue === 0;
}
